import "./FilterCommon.css";
import SimpleCardBox from "../cards/SimpleCardBox";

const FilterStack = ({children, footerContent}) => (
    <div className={"filter-stack"}>
        <SimpleCardBox defaultPadding={false} defaultMargin={false}>
            <div className={"filter-content"}>
                {children}
            </div>
            {footerContent ? <div className={"filter-footer"}>
                {footerContent}
            </div> : null}
        </SimpleCardBox>
    </div>
);

export default FilterStack;